var r=Array.isArray;export{r as default};
//# sourceMappingURL=isArray.js.map
